import axios from '@/libs/api.request'

export const getRouterReq = (access) => {
  return axios.request({
    url: 'get_router',
    params: {
      access
    },
    method: 'get'
  })
}
export const mainList = (param) => {
  return axios.request({
    url: '/menu/getMenu',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/routers.js